<template>
  <div>
    <el-input
      class="currency-input"
      :disabled="disabled"
      :size="size"
      type="text"
      v-model="displayValue"
      @blur="isInputActive = false"
      @focus="isInputActive = true" />
  </div>
</template>

<script>
export default {

  props: {
    value: {
      type: Number,
    },
    size: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    currencySymbol: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.value == null) return ''
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString()
        } else {
          let formatter
          if (this.currencySymbol) {
            formatter = new Intl.NumberFormat('id', {

              style: 'currency',
              currency: 'IDR',
            // the default value for minimumFractionDigits depends on the currency
            })
          } else {
            formatter = new Intl.NumberFormat('id')
          }
          return formatter.format(this.value)
        }
      },
      set: function (modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''))
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  },

}

</script>

<style lang="scss">
.currency-input {
  .el-input__inner {
    padding: 0px 0.3rem;
  }
}
</style>
